import { useTranslation } from 'react-i18next';
import './TabNavigation.css';

interface TabNavigationProps {
    step: number;
}

const TabNavigation = ({ step }: TabNavigationProps) => {
    const { t } = useTranslation();

    return (
        <div className="tab-navigation-container primotech-mobile-tabs">
            <div className={`tab-item ${step >= 1 ? 'tab-item-active' : 'tab-item-inactive'}`}>
                <div className="tab-item-icon">1️⃣</div>
                <div className={`tab-item-label ${step >= 1 ? 'tab-item-label-active' : 'tab-item-label-inactive'}`}>
                    {t('primotech.sessionCreated') || 'Session'}
                </div>
            </div>
            <div className={`tab-item ${step >= 2 ? 'tab-item-active' : 'tab-item-inactive'}`}>
                <div className="tab-item-icon">📞</div>
                <div className={`tab-item-label ${step >= 2 ? 'tab-item-label-active' : 'tab-item-label-inactive'}`}>
                    {t('primotech.phoneNumber') || 'Phone'}
                </div>
            </div>
            <div className={`tab-item ${step >= 3 ? 'tab-item-active' : 'tab-item-inactive'}`}>
                <div className="tab-item-icon">🔐</div>
                <div className={`tab-item-label ${step >= 3 ? 'tab-item-label-active' : 'tab-item-label-inactive'}`}>
                </div>
            </div>
        </div>
    );
};

export default TabNavigation;
